import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactElement, useCallback } from 'react';
import { ReactNode } from 'react';

export type Interface = {
	children: string | ReactNode;
	className?: string;
	onClick: VoidFunction;
	disabled?: boolean;
};

const styles = css`
	cursor: pointer;
	text-align: center;
	user-select: none;
`;

const Component = ({ className = '', onClick, disabled = false, children }: Interface): ReactElement => {
	const onKeyPress = useCallback(
		(e: React.KeyboardEvent<HTMLDivElement>): void => {
			if (e.key === 'Enter') {
				onClick();
			}
		},
		[onClick]
	);
	return (
		<div
			className={className}
			onKeyPress={onKeyPress}
			tabIndex={0}
			onClick={disabled ? (): void => void 0 : onClick}
		>
			{children}
		</div>
	);
};

export const Button = styled(Component)(styles);
